import { render, staticRenderFns } from "./CompanySign.vue?vue&type=template&id=5addfa0e&scoped=true&"
import script from "./CompanySign.vue?vue&type=script&lang=js&"
export * from "./CompanySign.vue?vue&type=script&lang=js&"
import style0 from "./CompanySign.vue?vue&type=style&index=0&id=5addfa0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5addfa0e",
  null
  
)

export default component.exports